import { render } from "./SuccessCheckTicketOther.vue?vue&type=template&id=f0fd08f2"
import script from "./SuccessCheckTicketOther.vue?vue&type=script&lang=js"
export * from "./SuccessCheckTicketOther.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__